import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { CommonService } from '../../../../shared/common.service';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
import { FinancialpositionService } from '../../financialposition/financialposition.service';
import { CreditorsServiceService } from '../creditors/creditors-service.service';

@Component({
  selector: 'app-creditorsmorethanyear',
  templateUrl: './creditorsmorethanyear.component.html',
  styleUrls: ['./creditorsmorethanyear.component.scss']
})
export class CreditorsmorethanyearComponent implements OnInit {
  credform_morethanyear: FormGroup
  APPeriodId: any; isJump: any;
  credid: any;
  mcredid: any;
  balancesheetvalues: any
  Creditorsmoreyear: any;
  CreditorsmoreyearLy: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, private credservice: CreditorsServiceService, public commonService: CommonService, private router: Router, public balanceSheetService: FinancialpositionService, public sidenav: SideNavService) { }
  ngOnInit() {
    this.createCreditorsForm_MorethanOneYear();
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getBalanceSheetData(this.APPeriodId);
    this.getmorecred(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyearmore();
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
    this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.credform_morethanyear.disable()
   
  }

  getBalanceSheetData(apPeriodId) {
    debugger
    //if (this.commonService.AccountTemplateId == 11) {
    //  this.balanceSheetService.getBalanceSheetFRS101(apPeriodId).subscribe((data: any) => {
    //    this.balancesheetvalues = data;
    //    this.Creditorsmoreyear = Math.abs(data.TradeAndOtherPayables);
    //    this.CreditorsmoreyearLy = Math.abs(data.TradeAndOtherPayables_LY);
    //    this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].disable();
    //    this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].disable();
    //  })
    //}
   // else {
      this.balanceSheetService.getBalanceSheet(apPeriodId).subscribe((data: any) => {
        this.balancesheetvalues = data;
        this.Creditorsmoreyear = Math.abs(data.CreditorsAmountsFallingDueAfterMoreThanOneYear);
        this.CreditorsmoreyearLy = Math.abs(data.CreditorsAmountsFallingDueAfterMoreThanOneYear_LY);
        this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].disable();
        this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].disable();
      })
    //}
  }


  createCreditorsForm_MorethanOneYear() {
    this.credform_morethanyear = this.formbuilder.group({
      CreditorsMoreThanOneYearId: new FormControl(),
      APPeriodId: new FormControl(),
      BankBorrowings: new FormControl(),
      BankBorrowings_LY: new FormControl(),
      AndicaFinanceLeaseLiabilitiesPresentValueTotal: new FormControl(),
      AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY: new FormControl(),
      AndicaOtherCreditors: new FormControl(),
      AndicaOtherCreditors_LY: new FormControl(),
      AndicaCreditorsDueAfterOneYear: new FormControl(),
      AndicaCreditorsDueAfterOneYear_LY: new FormControl(),
      SecurityDebts: new FormControl(),
      CreditorsFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }
  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.credform_morethanyear.reset()
      }
    })
  }
  Insertmorecred() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.credform_morethanyear.controls['APPeriodId'].setValue(this.APPeriodId)
    this.credform_morethanyear.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.credform_morethanyear.getRawValue();
    if (this.mcredid) {
      formdata.CreditorsMoreThanOneYearId = this.mcredid
      //this.credform_morethanyear.controls['CreditorsWithInOneYearId'].setValue(this.mcredid)
    }
    this.credservice.insertmorecred(formdata).subscribe((data) => {
    })
  }

  getmorecred(APPeriodId) {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.credservice.getmorecredators(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.credform_morethanyear.patchValue(data);
        this.mcredid = data.CreditorsMoreThanOneYearId;
      }
      this.commonService.getNotesData();
    })
  }

  getlastyearmore() {
    this.credservice.getmorecredatorsLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }

  save() {
    debugger
    if (this.Validations()) {
     this.Insertmorecred();
       this.credform_morethanyear.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Creditors - more than one year", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == "creditors-morethanoneyear") {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    }
    else {
      this.NormalRoutng = false;
      return false;
    }

  }

  back() {
    this.credform_morethanyear.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Creditors - more than one year", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }


  calculationsMoreThanOneYear() {
    debugger
    const total = parseFloat((this.credform_morethanyear.controls['BankBorrowings'].value == "" || this.credform_morethanyear.controls['BankBorrowings'].value == null) ? 0 : this.credform_morethanyear.controls['BankBorrowings'].value)
      +
      parseFloat((this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear'].value == "" || this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear'].value)
      + parseFloat((this.credform_morethanyear.controls['AndicaOtherCreditors'].value == "" || this.credform_morethanyear.controls['AndicaOtherCreditors'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaOtherCreditors'].value)

    this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].setValue(total);
  }
  calculationsMoreThanOneYear_LY() {
    const total = parseFloat((this.credform_morethanyear.controls['BankBorrowings_LY'].value == "" || this.credform_morethanyear.controls['BankBorrowings_LY'].value == null) ? 0 : this.credform_morethanyear.controls['BankBorrowings_LY'].value)
      +
      parseFloat((this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear_LY'].value == "" || this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear_LY'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaCreditorsDueAfterOneYear_LY'].value)
      + parseFloat((this.credform_morethanyear.controls['AndicaOtherCreditors_LY'].value == "" || this.credform_morethanyear.controls['AndicaOtherCreditors_LY'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaOtherCreditors_LY'].value)

    this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].setValue(total);
  }


  Validations() {
    if (this.commonService.showControl == true) {
    if (((this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value == "" || this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value) != this.Creditorsmoreyear) {
      Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Creditors-amounts falling due after more than one year value in the balance sheet for the year " + this.commonService.StartYear + ".", 'warning')
      return false;
    }

    else if (((this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].value == "" || this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal_LY'].value) != this.CreditorsmoreyearLy) {
      Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.LastYear + " must tally with the Creditors-amounts falling due after more than one year value in the balance sheet for the year " + this.commonService.LastYear + ".", 'warning')
      return false;
    }
    else {
      return true;
    }
    }
    else {
      if (((this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value == "" || this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value == null) ? 0 : this.credform_morethanyear.controls['AndicaFinanceLeaseLiabilitiesPresentValueTotal'].value) != this.Creditorsmoreyear) {
        Swal.fire('Andica Accounts Production', "Total value for the year " + this.commonService.StartYear + " must tally with the Creditors-amounts falling due after more than one year value in the balance sheet for the year " + this.commonService.StartYear + ".", 'warning')
        return false;
      }
      else {
        return true;
      }
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.credform_morethanyear.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br><span>Do you want to save your changes before leaving?</span>",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        this.NormalRoutng = true;
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }
}
